import { BaasMeetpuntService, BarStopwatch } from '@lvflanders/bar';

import { baasCoreContext } from '../baas-core.context';

// https://netbasal.com/inspiration-for-custom-decorators-in-angular-95aeb87f072c
/**
 * Measures the duration of a directive or component (which is a directive) between ngOnInit and ngAfterViewInit.
 */
export function BarMeetpunt(): ClassDecorator {
    return function (constructor: any) {
        // get meetpunt service through static injector on the core module
        const meetpunt: BaasMeetpuntService = baasCoreContext.injector.get(BaasMeetpuntService);
        const ngOnInit = constructor.prototype.ngOnInit;

        let stopwatch: BarStopwatch = null;
        // override the ngOnInit
        constructor.prototype.ngOnInit = function (...args) {
            // create and start new watch
            stopwatch = new BarStopwatch();
            stopwatch.start();
            // call original ngOnInit after starting the watch (if present)
            ngOnInit && ngOnInit.apply(this, args);
        };

        const ngAfterViewInit = constructor.prototype.ngAfterViewInit;
        // override the ngAfterViewInit
        constructor.prototype.ngAfterViewInit = function (...args) {
            // call original ngAfterViewInit if present
            ngAfterViewInit && ngAfterViewInit.apply(this, args);
            // stop the watch
            stopwatch.stop();
            // call meetpunt service to log this
            meetpunt.log({
                meetpunt: 'DIRECTIVE',
                meetpuntDetail: constructor.name,
                waarde: stopwatch.duration,
                meetpuntInfo: document.location.href
            });
            stopwatch = null;
        };
    };
}
